import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './Tabs.scss';

const Tabs = ({ items }) => {
	const [activeTabNum, setActiveTabNum] = useState(0);
	const prevTabNumber = useRef('fade-to-left');

	const TabContent = items[activeTabNum]?.component || <></>;

	const changeRef = () => {
		if (prevTabNumber.current === 'fade-to-left') {
			prevTabNumber.current = 'fade-to-right';
		} else {
			prevTabNumber.current = 'fade-to-left';
		}
	};

	return (
		<>
			<div className='Tabs'>
				{items.map((el, i) => (
					<div
						key={i}
						to={el?.to}
						onClick={() => setActiveTabNum(i)}
						className={classNames('Tabs-item', {
							active: i === activeTabNum,
						})}
					>
						{el?.name}
					</div>
				))}
			</div>

			<TransitionGroup className='Tabs-body'>
				<CSSTransition
					key={activeTabNum}
					timeout={700}
					className={prevTabNumber.current}
					onEntered={el => {
						if (el.classList.contains('fade-to-left')) {
							el.classList.replace('fade-to-left', 'fade-to-right');
						} else {
							el.classList.replace('fade-to-right', 'fade-to-left');
						}
					}}
					onExited={el => changeRef()}
					unmountOnExit
				>
					<div>{TabContent}</div>
				</CSSTransition>
			</TransitionGroup>
		</>
	);
};

Tabs.propTypes = {
	items: PropTypes.array,
};

export default Tabs;
